const validateString = (str) => {
  return str.replaceAll(' ', '').length > 0;
};

export default validateString;
